<template>
  <div
    id="service"
    class="service"
  >
    <div class="service__container wrap">
      <title-bar
        title-light="服务"
        title="项目"
        desc="本着服务至上的原则"
      ></title-bar>
      <div class="service__main">
        <div class="main-l">
          <ul class="list">
            <li
              :class="['list-item', {active: activeIndex === index}]"
              v-for="(item, index) in list"
              :key="index"
              @click="handleListItemClick(index)"
            >
              <div class="index">{{'0'+(index+1)}}</div>
              <div class="content">
                <h3>{{item.title}}</h3>
                <p>{{item.desc}}
                </p>
              </div>
              <img
                v-show="activeIndex !== index"
                class="arrow"
                src="@/assets/images/home/service-content/arrow-gray.svg"
                alt=""
              >
              <img
                v-show="activeIndex === index"
                :class="['arrow', {active: activeIndex === index}]"
                src="@/assets/images/home/service-content/arrow-light-yellow.png"
                alt=""
              >
            </li>
          </ul>
        </div>
        <div class="main-r">
          <h3 class="title">{{list[activeIndex].title}}</h3>
          <p class="dots">...</p>
          <p class="description">{{list[activeIndex].content}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar'

export default {
  name: 'Service',
  data () {
    return {
      list: [
        {
          title: '社会信息调查',
          desc: '信息收集 科学调查',
          content: '社会信息调查是针对社会生活中的某一情况、某一事件、某一问题，进行深入细致地调查研究，我司提供的社会信息调查，具有信息质量高，信息真实性强，调查样本库大，调查速度及时四大特点'
        },
        {
          title: '市场调查分析',
          desc: '分析研究 构建全新数据平台',
          content: '市场调查分析是对市场供需变化的各种因素及其动态、趋势的分析。分析过程是： 搜集有关资料和数据，采用适当的方法，分析研究、探索市场变化规。能让客户对市场上所需要了解的信息进行分析。分析结果可以让客户了解市场对某种产品的需求量和销售趋势，了解产品的市场占有率和竞争单位的市场占有情况，了解社会商品购买力和社会商品可供量的变化。帮助客户或提高决策质量，或提升绩效表现，或影响公共事务决策，或创新公共服务运作，或构建全新数据平台'
        },
        {
          title: '统计报表代理',
          desc: '分析整理 帮助客户节省时间',
          content: '统计报表是指各级企事业、行政单位按规定的表格形式、内容、时间要求报送程序，自上而下统一布置，提供统计资料的一种统计调查方式。但通常统计报表的制作费时费力，自作不易，而且需要专门的数据分析师对统计报表中的数据进行处理分析。我司有专门的数据分析师为客户所需要的统计报表进行数据分析整理，以及制作统计报表，帮助客户省时省力'
        }
      ],
      activeIndex: 0
    }
  },
  methods: {
    handleListItemClick (index) {
      this.activeIndex = index
    }
  },
  components: {
    TitleBar
  }
}
</script>

<style lang="less" scoped>
.service {
  padding: 0 0 60px;
  .title-bar {
    padding: 60px 0 100px;
  }
  &__main {
    box-sizing: border-box;
    display: flex;
    .main-l {
      margin-right: 125px;
      .list {
        &-item {
          h3,
          p {
            margin: 0;
            line-height: 100%;
          }
          box-sizing: border-box;
          display: flex;
          align-items: center;
          padding: 40px 30px 30px;
          position: relative;
          width: 366px;
          color: #9da0b3;
          .index {
            margin-right: 15px;
            font-size: 50px;
            font-weight: bold;
            line-height: 100%;
            cursor: pointer;
          }
          .content {
            position: relative;
            h3,
            p {
              display: flex;
              align-items: center;
              white-space: nowrap;
            }
            h3 {
              margin-bottom: 10px;
              font-size: 20px;
              font-weight: 400;
            }
            p {
              font-size: 16px;
            }
            cursor: pointer;
          }
          .arrow {
            position: absolute;
            bottom: 32px;
            right: 30px;
            width: 19px;
            height: 16px;
            cursor: pointer;
            transition: 0.2s;
            &.active {
              right: 15px;
              bottom: 15px;
              width: 51px;
              height: 51px;
              &:hover {
                transform: scale(1.2);
              }
            }
          }
          &.active {
            color: #000;
            background-image: linear-gradient(to right, #fcc961, #ffb05a);
          }
        }
      }
    }
    .main-r {
      flex: 1;
      // width: calc(1200px - 406px - 125px);
      .title {
        font-size: 26px;
        font-weight: 400;
      }
      .dots {
        margin-top: 25px;
        margin-bottom: 30px;
        font-size: 26px;
        line-height: 100%;
        color: #fdce63;
      }
      .description {
        font-size: 16px;
        line-height: 24px;
        color: #6b6b6b;
      }
    }
  }
}
</style>
